// extracted by mini-css-extract-plugin
module.exports = {"divider-container":"TextDivider_divider-container__TvsZ_","divider-text":"TextDivider_divider-text__oMvxc"};